import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-copy',
    templateUrl: './copy.component.html',
    styleUrls: ['./copy.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class CopyComponent {
    currentYear = new Date().getFullYear();
}
